<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          약국명 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          ref="refHospital"
          placeholder="약국명을 입력해 주세요"
          :height="formHeight"
          :rules="[requiredRuleByItem('약국명')]"
          v-model="userData.hospital"
          append-icon="mdi-check"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          약국주소 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          readonly
          ref="refHospitalAddr"
          placeholder="주소를 입력해 주세요"
          :height="formHeight"
          :rules="[requiredRuleByItem('약국주소')]"
          v-model="userData.hospitalAddr"
        >
          <!-- 인풋 안쪽 끝에 항상 버튼 -->
          <template #append>
            <v-btn
              small
              rounded
              class="btn-text-white"
              color="mainColorDark"
              @click.stop="openPostcode"
            >
              주소찾기
            </v-btn>
          </template>
        </v-text-field>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>

import { requiredRuleByItem } from "@/utils/rules.js";

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      requiredRuleByItem
    };
  },
  methods: {
    openPostcode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.userData.hospitalAddr = data.roadAddress;

          // 주소 입력 후 인풋에 포커스 유지
          this.$nextTick(() => {
            const input = this.$refs.refHospitalAddr?.$el.querySelector('input');
            if (input) {
              input.focus();
              input.setSelectionRange(input.value.length, input.value.length);
            }
          });
        },
      }).open();
    },
  },
};
</script>
